import React from "react";

// document.body.innerHTML = svgGraph({
//   LOWEST_SCORE: 450,
//   HIGHEST_SCORE: 800,
//   rejectionScore: 575,
//   acceptanceScore: 750, 
//   calcScore: 700,
// });

export default function SvgGraph({ width, LOWEST_SCORE, HIGHEST_SCORE, rejectionScore, acceptanceScore, calcScore }) {
  
  // graph vars
  const height = 140;
  const marginX = 15;
  const marginY = 20;
  const lineX = 67;
  const lineY = 85;
  const lineYScore = 56;

  // clac vars
  const relativeX = (width - marginX * 2) / (HIGHEST_SCORE - LOWEST_SCORE);
  let lineXRed = marginX + Math.floor( relativeX * (rejectionScore - LOWEST_SCORE) );
  let lineXGreen = marginX + Math.floor( relativeX * (acceptanceScore - LOWEST_SCORE) );
  let lineXBlue = calcScore && marginX + Math.floor( relativeX * (calcScore - LOWEST_SCORE) );
    
  // get diff
  const diff = Math.hypot(lineXGreen - lineXRed);

  // fix texts spaces
  if (diff < 50) {
    // move lineXBlue
    if (lineXBlue <= lineXRed && lineXBlue > lineXRed / 3) {
      lineXBlue -= (15 - diff / 2);
    } else if (lineXBlue >= lineXGreen && lineXBlue < (lineXGreen + lineXGreen / 3)) {
      lineXBlue += (15 - diff / 2);
    }
    // move lineXRed & lineXBlue
    lineXRed -= 15 - diff / 2;
    lineXGreen += 15 - diff / 2;
  }

  // limit lineXBlue
  if (lineXBlue < marginX) {
    lineXBlue = marginX - 3;
  } else if (lineXBlue > width - marginX) {
    lineXBlue = width - marginX + 3;
  }
  
  const svg = `<svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.0"
      encoding="UTF-8"
      width="${width}"
      viewBox="0 0 ${width} ${height}"
      shape-rendering="optimizespeed"
    >

    <style type="text/css">
      .line-y, .line-x { stroke: #e5e5e5; stroke-width: 0.5; }
      .line-red { stroke: #ff514e; stroke-width: 2; }
      .line-grey { stroke: #d7d7d7; stroke-width: 2; }
      .line-green { stroke: #3cb878; stroke-width: 2; }
      .line-blue { stroke: #0097f0; stroke-width: 2; stroke-dasharray: 0,4; stroke-linecap: round; shape-rendering: geometricprecision; }
      .circle { fill: #e5e5e5; }
      .circle-blue { fill: #0097f0; shape-rendering: geometricprecision; }
      .text {
        fill: #252525;
        text-anchor: middle;
        alignment-baseline: middle;
        font-family: OpenSansHebrew;
        font-size: 1em;
        font-weight: 300;
      }
    </style>

    <line class="line-x" x1="${marginX}" y1="${lineX}" x2="${width-marginX}" y2="${lineX}" />

    <!-- LOWEST_SCORE line -->
    <line class="line-y" x1="${marginX}" y1="${marginY}" x2="${marginX}" y2="${lineY}" />
    <circle class="circle" cx="${marginX}" cy="${lineX}" r="2" />
    <text class="text" x="${marginX}" y="${lineY + 6}">${LOWEST_SCORE}</text>
  
    <!-- rejection y line -->
    <line class="line-y" x1="${lineXRed}" y1="${marginY}" x2="${lineXRed}" y2="${lineY}" />
    <circle class="circle" cx="${lineXRed}" cy="${lineX}" r="2" />
    <text class="text" x="${lineXRed}" y="${lineY + 6}">${rejectionScore}</text>
  
    <!-- acceptance y line -->
    ${ lineXRed != lineXGreen ? `
      <line class="line-y" x1="${lineXGreen}" y1="${marginY}" x2="${lineXGreen}" y2="${lineY}" />
      <circle class="circle" cx="${lineXGreen}" cy="${lineX}" r="2" />
      <text class="text" x="${lineXGreen}" y="${lineY + 6}">${acceptanceScore}</text>
    ` : '' }
  
    <!-- HIGHEST_SCORE line -->
    <line class="line-y" x1="${width-marginX}" y1="${marginY}" x2="${width-marginX}" y2="${lineY}" />
    <circle class="circle" cx="${width-marginX}" cy="${lineX}" r="2" />
    <text class="text" x="${width-marginX}" y="${lineY + 6}">${HIGHEST_SCORE}</text>
  
    <!-- line y bars -->
    <line class="line-red" x1="${marginX}" y1="${lineX - 14}" x2="${lineXRed}" y2="${lineX - 14}" />
    <line class="line-grey" x1="${lineXRed}" y1="${lineX - 21}" x2="${lineXGreen}" y2="${lineX - 21}" />
    <line class="line-green" x1="${lineXGreen}" y1="${lineX - 28}" x2="${width-marginX}" y2="${lineX - 28}" />
  
    <!-- line x blue -->
    ${ lineXBlue ? `
      <circle class="circle-blue" cx="${lineXBlue - (0.15)}" cy="7.5" r="2" />
      <line class="line-blue" x1="${lineXBlue}" y1="12" x2="${lineXBlue}" y2="${lineY + 28}" />
      <circle class="circle-blue" cx="${lineXBlue - (0.15)}" cy="${lineY + 30}" r="2" />
      <text class="text" x="${lineXBlue}" y="${lineY + 40}">${calcScore}</text>
    ` : '' }

  </svg>`;

  return (
    <div className="svg-graph" dangerouslySetInnerHTML={{ __html: svg }}></div>
  );
}
